import React, { useEffect } from 'react';
import { X, Edit2, Box, MapPin, Crosshair } from 'lucide-react';
import './WarehouseDetailsPanel.css';

export default function WarehouseDetailsPanel({ isOpen, onClose, warehouseData, onEdit }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !warehouseData) return null;

  const percentage = warehouseData.capacity > 0 ? (warehouseData.currentStock / warehouseData.capacity) * 100 : 0;
  const formattedPercentage = percentage.toFixed(1);

  let progressColorClass = 'progress-green';
  if (percentage >= 60 && percentage < 85) {
    progressColorClass = 'progress-yellow';
  } else if (percentage >= 85) {
    progressColorClass = 'progress-red';
  }

  const latFormat = warehouseData.coordinates?.lat ? `${warehouseData.coordinates.lat.toFixed(4)}° N` : 'N/A';
  const lngFormat = warehouseData.coordinates?.lng ? `${warehouseData.coordinates.lng.toFixed(4)}° E` : 'N/A';

  return (
      <>
        <div className="panel-backdrop" onClick={onClose}></div>
        <div className="warehouse-details-panel">
          <div className="panel-header">
            <h2>Warehouse Details</h2>
            <div className="panel-header-actions">
              <button className="panel-edit-btn" onClick={() => onEdit && onEdit(warehouseData)} title="Edit Warehouse">
                <Edit2 size={18} />
                <span>Edit</span>
              </button>
              <button className="panel-close-btn" onClick={onClose}>
                <X size={20} />
              </button>
            </div>
          </div>

          <div className="panel-content">
            <div className="panel-warehouse-profile">
              <div className="warehouse-icon-large">
                <Box size={32} />
              </div>
              <div className="warehouse-title-info">
                <h3>{warehouseData.name}</h3>
                <p className="warehouse-id-text">{warehouseData.id}</p>
              </div>
            </div>

            <div className="panel-section">
              <h3 className="panel-section-title">Location Information</h3>
              <div className="panel-icon-row">
                <MapPin size={16} className="panel-icon" />
                <div>
                  <p className="panel-label" style={{marginBottom: 0}}>Address / Region</p>
                  <p className="panel-value-bold">{warehouseData.location || 'N/A'}</p>
                </div>
              </div>
              <div className="panel-icon-row">
                <Crosshair size={16} className="panel-icon" />
                <div>
                  <p className="panel-label" style={{marginBottom: 0}}>Coordinates</p>
                  <p className="panel-value-bold">{latFormat}, {lngFormat}</p>
                </div>
              </div>
            </div>

            <div className="panel-section">
              <h3 className="panel-section-title">Storage Utilization</h3>
              <div className="warehouse-storage-info">
                <div className="warehouse-storage-header">
                  <span className="current-stock-large">{warehouseData.currentStock}</span>
                  <span className="capacity-text"> / {warehouseData.capacity} units</span>
                </div>

                <div className="warehouse-progress-container-panel">
                  <div
                      className={`warehouse-progress-bar-panel ${progressColorClass}`}
                      style={{ width: `${percentage}%` }}
                  ></div>
                </div>

                <div className="warehouse-storage-footer">
                  {formattedPercentage}% utilized
                </div>
              </div>
            </div>



          </div>
        </div>
      </>
  );
}
